// interventions.ts — Typen fuer den Interventionskatalog (in Sync mit kpi-orchestrator dev-v135).
export type Intervention = {
  tenant: "impulse" | "1und1";
  code: string;
  name: string;
  kerndomaene_code?: string | null;
  kerndomaene_name?: string | null;
  weitere_domaenen_codes?: string[] | null;
  domaenen_alle_codes?: string[] | null;
  phase?: string | null;
  ebene?: string | null;
  haerte?: string | null;
  ke_kat?: string | null;
  personenabhaengigkeit?: string | null;
  kurzbeschreibung?: string | null;
  nutzen_kundensicht?: string | null;
  wann_sinnvoll?: string | null;
  ziel?: string | null;
  wirkung?: string | null;
  wirkprinzip?: string | null;
  nicht_einsetzen?: string | null;
  rechtlicher_vorbehalt?: string | null;
  rechtlicher_vorbehalt_detail?: string | null;
  hat_rechtlichen_vorbehalt?: boolean;
  kategorie?: string | null;
  kategorie_code?: string | null;
  zielwirkung?: string | null;
  impulse_code?: string | null;
  is_1und1_spezifisch?: boolean | null;
  katalog_version?: string | null;
  source?: string | null;
};
export type IkMeta = { quelle?: string; katalog_version?: string; hinweis?: string };
export type IkList = { tenant: string; count: number; items: Intervention[]; _meta?: IkMeta };
export type IkOne = { tenant: string; intervention: Intervention; _meta?: IkMeta };
export type IkMatchHit = { code: string; score: number; warum: string[]; intervention: Intervention };
export type IkMatch = { tenant: string; situation_text: string; count: number; results: IkMatchHit[]; _meta?: IkMeta };

export const DOMAENEN: Record<string,string> = {
  "D-OE":"OE & Change","D-FUEHR":"Führung & Team","D-KULT":"Kultur & Werte","D-STRAT":"Strategie & M&A",
  "D-PROZ":"Prozess & Operations","D-TECH":"Technik & IT","D-KI":"KI & Daten","D-KUNDE":"Kunde & Markt",
  "D-PERS":"Personal & Restrukturierung",
};
export const HAERTE = ["weich","mittel","hart"];
export const PHASEN = ["kontrakt","diagnose","umsetzung","abschluss"];
